"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader, CircleCheck, CircleAlert } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureYourStrategyCall() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}
function StrategyForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-12 text-center space-y-4 animate-in fade-in zoom-in duration-500">
        <div className="size-16 rounded-full bg-primary/10 flex items-center justify-center border border-primary/20">
          <CircleCheck className="size-8 text-primary" />
        </div>
        <h3 className="text-2xl font-bold text-slate-200">Registration Submitted</h3>
        <p className="text-muted-foreground max-w-md">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="full_name" rules={{
        required: "Full Name is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-slate-400 font-medium">Full Name</FormLabel>
              <FormControl>
                <Input placeholder="Your Full Name" {...field} className="bg-[#05070a]/80 border-slate-800 focus:border-primary focus:ring-1 focus:ring-primary/20 transition-all h-12 text-slate-200" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Email Address is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-slate-400 font-medium">Email Address</FormLabel>
              <FormControl>
                <Input type="email" placeholder="your@email.com" {...field} className="bg-[#05070a]/80 border-slate-800 focus:border-primary focus:ring-1 focus:ring-primary/20 transition-all h-12 text-slate-200" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="phone" rules={{
        required: "Phone number is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-slate-400 font-medium">Contact Number</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="Your phone number" {...field} className="bg-[#05070a]/80 border-slate-800 focus:border-primary focus:ring-1 focus:ring-primary/20 transition-all h-12 text-slate-200" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="username" rules={{
        required: "Username is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-slate-400 font-medium">Username</FormLabel>
              <FormControl>
                <Input placeholder="Your username" {...field} className="bg-[#05070a]/80 border-slate-800 focus:border-primary focus:ring-1 focus:ring-primary/20 transition-all h-12 text-slate-200" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="password" rules={{
      required: "Password is required",
      minLength: {
        value: 6,
        message: "Password must be at least 6 characters"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-slate-400 font-medium">Password</FormLabel>
            <FormControl>
              <Input type="password" placeholder="Create a password" {...field} className="bg-[#05070a]/80 border-slate-800 focus:border-primary focus:ring-1 focus:ring-primary/20 transition-all h-12 text-slate-200" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-lg flex items-center gap-3 text-destructive animate-in fade-in slide-in-from-top-2">
          <CircleAlert className="size-5 shrink-0" />
          <p className="text-sm font-medium">{submitError}</p>
        </div>}

      <div className="pt-4">
        <Button type="submit" disabled={isSubmitting} className="w-full h-14 text-lg font-bold uppercase tracking-widest bg-gradient-to-b from-slate-100 via-slate-300 to-slate-400 hover:from-white hover:to-slate-200 text-slate-950 transition-all duration-300 shadow-[0_0_25px_rgba(59,130,246,0.15)] hover:shadow-[0_0_35px_rgba(59,130,246,0.25)] border-none rounded-md">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-5" />
              Creating Account...
            </> : 'CREATE ACCOUNT'}
        </Button>
        <p className="text-center text-xs text-muted-foreground mt-4 font-medium tracking-wide">
          After submitting your registration, we will contact you directly with the next steps for account setup and service access.
        </p>
      </div>
    </Form>;
}